/**
 * 辅助函数
 */

/**
 * 根据restful的uri构建实际url
 * @param uri uri模版
 * @param argv 插入到uri中的参数列表，按顺序插入
 * @returns url
 */
export function buildURL(uri, ...argv) {
    return uri.replace(/{\w+}|:[a-zA-Z]+/g, () => {
        const res = argv.shift();

        if (res === undefined) {
            throw new Error('URI 参数不足');
        }
        return res;
    });
}

/**
 * 选取原object指定属性，构成新的object
 * @param originObject
 * @param pickKeys
 */
export function pick(originObject, pickKeys = []) {
    const newObject = {};
    pickKeys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(originObject, key)) {
            newObject[key] = originObject[key];
        }
    });
    return newObject;
}

/**
 * 更新target对象的键值，使用source对象里的数据
 * @param target
 * @param source
 */
export function update(target, source) {
    const result = { ...target };
    Object.keys(target).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            result[key] = source[key];
        }
    });
    return result;
}
